import { ContentWithLoading } from '@/components/ui/ContentWithLoading';
import { useDraftPools } from '@/hooks/queries/usePoolQueries';
import PoolCard from './PoolCard';

type DraftPoolListProps = {
  onBackToReady: () => void;
};

export function DraftPoolList({ onBackToReady }: DraftPoolListProps) {
  const { data: draftPools, isLoading } = useDraftPools();
  const drafts = draftPools?.draft_pools ?? [];

  return (
    <div className="w-full flex flex-col gap-4">
      <button
        type="button"
        onClick={onBackToReady}
        className="self-start flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer text-sm font-medium text-black [font-family:var(--ep-font-avenir)]"
      >
        Back to ready pools
      </button>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        <ContentWithLoading
          loading={isLoading}
          empty={!isLoading && drafts.length === 0}
          emptyTitle="No draft pools"
          emptySubtitle="You don't have any draft pools yet."
          className="col-span-full font-avenir"
        >
          {drafts.map((draft) => (
            <PoolCard key={draft.id} draft={draft} />
          ))}
        </ContentWithLoading>
      </div>
    </div>
  );
}
